// @flow
import type {Action as TypeaheadSuggestionActions} from '../actions/typeaheadSuggestion';
import type {SearchQueryCompleteAction} from '../actions/searchQuery';

export type State = $Shape<
    $PropertyType<TypeaheadSuggestionActions, 'payload'>
>;

const initialState = {};

export default function reducer(
    state: State = initialState,
    action: TypeaheadSuggestionActions | SearchQueryCompleteAction
): State {
    switch (action.type) {
        case 'TYPEAHEAD_SUGGESTION/INIT':
            return {...state, ...action.payload};
        case 'SEARCH_QUERY/COMPLETE':
            if (
                action.payload.results &&
                action.payload.results.typeaheadSuggestion
            ) {
                const {typeaheadSuggestion} = action.payload.results;
                return {
                    ...state,
                    term: typeaheadSuggestion.term,
                    uuid: typeaheadSuggestion.uuid
                };
            } else if (
                action.payload.results &&
                !action.payload.results.typeaheadSuggestion &&
                action.payload.results.geography
            ) {
                const {isGeocoded, name} = action.payload.results.geography;
                if (isGeocoded) {
                    return {
                        ...state,
                        term: name,
                        uuid: ''
                    };
                }
            }
            return state;
        default:
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
